import React, { useState } from 'react';
const faqs = [{
  q: 'How do I receive the material?',
  a: 'Immediately via email after payment. Once your purchase is confirmed, you get a link to download the entire bundle on your phone, tablet, or computer.'
}, {
  q: 'Is it for beginners?',
  a: "Yes, it's designed to provide the confidence and structure that new teachers need — with sequences, cues, and themes ready to use."
}, {
  q: 'What format are the files?',
  a: 'High-quality, printable PDF files ready for any device, whether you read on screen or prefer paper.'
}, {
  q: 'Is it a monthly subscription?',
  a: 'No. One-time payment, lifetime access. Once you buy it, the material is yours forever with no hidden fees.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-73">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-75">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-76">
                  <span className="font-bold text-text-main text-lg" data-id="element-77">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-78">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-79">
                  <p className="text-text-sec text-base" data-id="element-80">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}